import { t } from 'ember-intl';
import {
  HdsAlert,
  HdsLinkInline,
} from '@hashicorp/design-system-components/components';

const AlertBanner = <template>
  <HdsAlert @type="inline" @color="warning" ...attributes as |A|>
    <A.Title>
      {{@header}}
    </A.Title>
    <A.Description>
      {{t "components.page.account-settings.security.banner.body1"}}
      <HdsLinkInline
        @href={{t
          "components.page.account-settings.security.banner.learn.link"
        }}
        @isHrefExternal={{true}}
      >
        {{t "components.page.account-settings.security.banner.learn.copy"~}}
      </HdsLinkInline>,
      <HdsLinkInline
        @href={{t
          "components.page.account-settings.security.banner.discuss.link"
        }}
        @isHrefExternal={{true}}
      >
        {{t "components.page.account-settings.security.banner.discuss.copy"~}}
      </HdsLinkInline>,
      {{t "components.page.account-settings.security.banner.body2"}}
      <HdsLinkInline
        @href={{t
          "components.page.account-settings.security.banner.certificates.link"
        }}
        @isHrefExternal={{true}}
      >
        {{t
          "components.page.account-settings.security.banner.certificates.copy"
        ~}}
      </HdsLinkInline>.
    </A.Description>
  </HdsAlert>
</template>;

export default AlertBanner;
